import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { StaffResponse } from '../../api/generated';
import type { RootState } from '../index';

interface StaffState {
  staffById: Record<string, StaffResponse>;
  loading: boolean;
  error: string | null;
}

const initialState: StaffState = {
  staffById: {},
  loading: true,
  error: null
};

const staffSlice = createSlice({
  name: 'staff',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    setStaff: (state, action: PayloadAction<StaffResponse[]>) => {
      const staffById: Record<string, StaffResponse> = {};
      for (const s of action.payload) {
        staffById[s.id] = s;
      }
      state.staffById = staffById;
      state.loading = false;
      state.error = null;
    },
    upsertStaff: (state, action: PayloadAction<StaffResponse>) => {
      state.staffById[action.payload.id] = action.payload;
    },
    removeStaff: (state, action: PayloadAction<string>) => {
      delete state.staffById[action.payload];
    },
    clearStaff: (state) => {
      state.staffById = {};
      state.loading = false;
      state.error = null;
    }
  }
});

export const { setLoading, setError, setStaff, upsertStaff, removeStaff, clearStaff } =
  staffSlice.actions;

export const selectStaff = (state: RootState): StaffResponse[] =>
  Object.values(state.staffSlice.staffById);

export const selectStaffLoading = (state: RootState): boolean => state.staffSlice.loading;

export const selectStaffError = (state: RootState): string | null => state.staffSlice.error;

export default staffSlice.reducer;
